import { DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import PropTypes from 'prop-types'

const RulesDialogHeader = ({ title, description, icon }) => {
  const HeaderIcon = typeof icon === 'string' ? () => <img src={icon} alt="icon" /> : icon

  return (
    <DialogHeader>
      <div className="flex flex-row items-center gap-4">
        <div className="flex self-start items-center justify-center bg-gradient-to-r from-[#011824] to-[#00A6B6] min-w-12 min-h-12 rounded-[10px]">
          <HeaderIcon />
        </div>
        <div className="flex flex-col gap-2 pt-1">
          <DialogTitle className="leading-6 text-[#101828]">{title}</DialogTitle>
          <DialogDescription className="mt-[-4px] text-[#475467] mb-1">{description}</DialogDescription>
        </div>
      </div>
    </DialogHeader>
  )
}

RulesDialogHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]).isRequired,
}

export default RulesDialogHeader
